export default class FileFields {
  name?: string
  description?: string
  storagepath?: string

  constructor(obj: unknown) {
    Object.assign(this, obj)
  }
}
